import styled from '@emotion/styled'

interface StyleBannerProps {
  bgColor?: string
}

export const StyleBannerWrapper = styled.div`
  width: 100%;
  padding: 0 16px;
  height: auto;
  margin-top: 20px;
  @media (max-width: 480px) {
    padding: 0;
    margin: 0;
  }
`

export const StyleBanner = styled.div<StyleBannerProps>`
  height: 500px;
  background-color: ${(props: any) => props.bgColor || '#e6f5fc'};
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  padding: 0 30px;
  align-items: center;

  @media (max-width: 1024px) {
    flex-direction: column;
    justify-content: center;
    height: auto;
    padding: 40px 20px;
    text-align: center;
  }
`

export const StyleGradientText = styled.p`
  font-size: 2.5rem;
  font-weight: 700;
  background: linear-gradient(120deg, #274385, #2a95c4);
  background-clip: text;
  color: transparent;
  width: 700px;
  line-height: 4rem;
  @media (max-width: 1024px) {
    font-size: 2.2rem;
    line-height: 3rem;
    width: 100%;
  }

  @media (max-width: 600px) {
    font-size: 1.5rem;
    line-height: 1.7rem;
  }
`

export const StyleDownloadButtonsWrapper = styled.div<{
  marginTop?: string
  direction?: string
}>`
  display: flex;
  column-gap: 8px;
  margin-top: ${(props) => props.marginTop || 0}px;
  @media (max-width: 1024px) {
    margin-top: 20px;
    justify-content: center;
    flex-wrap: wrap;
    row-gap: 12px;
  }

  @media (max-width: 600px) {
    flex-direction: ${(props: any) =>
      props.direction === 'row' ? 'row' : 'column'};
    align-items: center;
    width: 100%;
  }
`
